import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChatUI } from "../components/Chat/Chat";
import { TerminalPageErrorBoundary } from "../components/ErrorBoundary";
import { useStore } from "../stores";

export const TerminalPage = () => {
  const navigate = useNavigate();
  const { uiStore } = useStore();

  const handleClose = () => {
    navigate(-1); // Go back to previous page
  };

  // Close the right sidebar on mount
  useEffect(() => {
    uiStore.setIsRightPanelOpen(false);
  }, []);

  return (
    <TerminalPageErrorBoundary>
      <div className="w-full h-full flex flex-1 flex-col items-center">
        <ChatUI onClose={handleClose} setMaxWidth />
      </div>
    </TerminalPageErrorBoundary>
  );
};
